export const getCollectionBagTitle = (title: string) => {
  if (title === "MEDIUMSKIPBAGCOLLECTIONONLY") return "Medium";
  if (title === "LARGESKIPBAGCOLLECTIONONLY") return "Large";
  if (title === "SMALLSKIPBAGCOLLECTIONONLY") return "Small";
  return "";
};
